import React, { useCallback } from 'react'
import useUiStore from '../../../shared/store/ui.store.tsx'
import { useShallow } from 'zustand/react/shallow'
import useTracksStore, {
  DEFAULT_MAX_PROJECT_DURATION,
} from '@/shared/store/tracks.store.tsx'

const ZoomBar = () => {
  const maxProjectDuration = useTracksStore((state) => state.maxProjectDuration)
  const { zoom, setZoom } = useUiStore(
    useShallow((state) => ({
      zoom: state.zoom,
      setZoom: state.setZoom,
    }))
  )

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setZoom(Number(e.target.value))
  }, [])

  const minZoom = maxProjectDuration > DEFAULT_MAX_PROJECT_DURATION ? 0.3 : 0.5
  const maxZoom = 2
  const range = maxZoom - minZoom
  const position = ((zoom - minZoom) / range) * 100

  return (
    <div className="flex items-center">
      <div className="relative flex h-4 w-[112px] items-center justify-center">
        <div className="absolute h-2 w-full border border-gray-800 bg-zinc-700"></div>

        <div
          className={`absolute h-4 w-1.5 rounded-sm bg-white shadow-md`}
          style={{ left: `${position}%`, transform: 'translateX(-50%)' }}
        ></div>

        <input
          type="range"
          min={minZoom}
          max={maxZoom}
          step="0.1"
          onChange={handleChange}
          className="h-4 w-[120px] cursor-pointer opacity-0"
        />
      </div>
    </div>
  )
}

export default React.memo(ZoomBar)
